import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/doc.svg'
import _imports_1 from '@/assets/docx.svg'
import _imports_2 from '@/assets/xls.svg'
import _imports_3 from '@/assets/xlsx.svg'
import _imports_4 from '@/assets/pdf.svg'
import _imports_5 from '@/assets/txt.svg'
import _imports_6 from '@/assets/png.svg'
import _imports_7 from '@/assets/jpg.svg'
import _imports_8 from '@/assets/jpeg.svg'
import _imports_9 from '@/assets/csv.svg'
import _imports_10 from '@/assets/zip.svg'
import _imports_11 from '@/assets/mp4.svg'
import _imports_12 from '@/assets/link.svg'
import _imports_13 from '@/assets/deleteIcon.svg'
import _imports_14 from '@/assets/sortBy.svg'
import _imports_15 from '@/assets/arrowRight.svg'
import _imports_16 from '@/assets/cancel.svg'
import _imports_17 from '@/assets/fileUploadIcon.svg'
import _imports_18 from '@/assets/Browse.svg'
import _imports_19 from '@/assets/warning.svg'
import _imports_20 from '@/assets/filter.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "row w-full flex-shrink-0 flex mt-2 justify-between" }
const _hoisted_3 = {
  key: 0,
  class: "title truncate min-w-0 max-w-[calc(100%-2.5rem)] pr-4"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_6 = {
  key: 3,
  class: "flex flex-row"
}
const _hoisted_7 = { class: "w-full minheight" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_12 = {
  key: 1,
  class: "h-full min-h-0"
}
const _hoisted_13 = { class: "descriptionToggle overflow-y-auto" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex flex-row" }
const _hoisted_16 = { class: "border border-lightgrey w-77 p-2 rounded-tr-md text-xs" }
const _hoisted_17 = { class: "flex flex-row" }
const _hoisted_18 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_19 = { class: "flex flex-row" }
const _hoisted_20 = { class: "border-t border-b border-l p-2 header borderwidth w-1/3 border-lightgrey text-sm" }
const _hoisted_21 = { class: "border p-2 header w-1/4 border-lightgrey rounded-tr-md text-sm" }
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = { class: "border-l border-b p-2 header w-1/4 border-lightgrey" }
const _hoisted_24 = { class: "border-b border-l p-2 borderwidth w-1/3 border-lightgrey text-xs" }
const _hoisted_25 = { class: "border-b border-l p-2 header w-1/4 border-lightgrey" }
const _hoisted_26 = { class: "border-r border-b border-l border-lightgrey w-1/4 text-xs p-2" }
const _hoisted_27 = { class: "flex flex-row" }
const _hoisted_28 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_29 = { class: "flex flex-row" }
const _hoisted_30 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_31 = {
  key: 0,
  class: "flex gap-3 flex-wrap"
}
const _hoisted_32 = { class: "pdf w-full rounded-sm" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_35 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_36 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_37 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_38 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_39 = {
  key: 5,
  src: _imports_5,
  alt: ""
}
const _hoisted_40 = {
  key: 6,
  src: _imports_6,
  alt: ""
}
const _hoisted_41 = {
  key: 7,
  src: _imports_7,
  alt: ""
}
const _hoisted_42 = {
  key: 8,
  src: _imports_8,
  alt: ""
}
const _hoisted_43 = {
  key: 9,
  src: _imports_9,
  alt: ""
}
const _hoisted_44 = {
  key: 10,
  src: _imports_10,
  alt: ""
}
const _hoisted_45 = {
  key: 11,
  src: _imports_11,
  alt: ""
}
const _hoisted_46 = {
  key: 12,
  src: _imports_4,
  alt: ""
}
const _hoisted_47 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_48 = { class: "ml-2 pb-1" }
const _hoisted_49 = ["title"]
const _hoisted_50 = { class: "flex justify-between w-full" }
const _hoisted_51 = { class: "ml-2 fontSize10PX" }
const _hoisted_52 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_53 = { class: "pdf w-full rounded-sm flex flex-row items-center" }
const _hoisted_54 = ["onClick", "aria-label"]
const _hoisted_55 = { class: "finding-evidence-link-icon__img-wrap" }
const _hoisted_56 = { class: "finding-evidence-link-icon__tooltip" }
const _hoisted_57 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_58 = { class: "ml-2 pb-1" }
const _hoisted_59 = ["title"]
const _hoisted_60 = { class: "flex justify-between w-full" }
const _hoisted_61 = { class: "ml-2 fontSize10PX" }
const _hoisted_62 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "flex flex-row" }
const _hoisted_65 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify rounded-br-md flex items-center" }
const _hoisted_66 = ["title"]
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "flex mb-1" }
const _hoisted_70 = { class: "w-6/12" }
const _hoisted_71 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_72 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_73 = { class: "w-6/12" }
const _hoisted_74 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_75 = { class: "flex mb-1" }
const _hoisted_76 = { class: "w-6/12" }
const _hoisted_77 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_78 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_79 = { class: "w-6/12" }
const _hoisted_80 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_81 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_82 = { class: "flex mb-1" }
const _hoisted_83 = { class: "w-6/12" }
const _hoisted_84 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_85 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_86 = { class: "w-6/12" }
const _hoisted_87 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_88 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_89 = { class: "w-full" }
const _hoisted_90 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_91 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_92 = { class: "w-full" }
const _hoisted_93 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_94 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_95 = { class: "w-full" }
const _hoisted_96 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_97 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_98 = { class: "w-full" }
const _hoisted_99 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_100 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_101 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_102 = { class: "row flex flex-row w-full" }
const _hoisted_103 = { class: "w-6/12" }
const _hoisted_104 = { class: "w-6/12 leftspacing" }
const _hoisted_105 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_106 = { class: "row flex flex-row w-full" }
const _hoisted_107 = { class: "w-6/12" }
const _hoisted_108 = { class: "w-6/12 leftspacing" }
const _hoisted_109 = { class: "formcontainer upperspacing" }
const _hoisted_110 = { class: "row flex flex-row w-full" }
const _hoisted_111 = { class: "w-3/6" }
const _hoisted_112 = { class: "w-3/6 leftspacing" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_115 = { class: "row flex flex-row w-full" }
const _hoisted_116 = { class: "w-6/12" }
const _hoisted_117 = { class: "w-6/12 leftspacing" }
const _hoisted_118 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_119 = { class: "row flex flex-row w-full" }
const _hoisted_120 = { class: "w-6/12" }
const _hoisted_121 = { class: "w-6/12 leftspacing" }
const _hoisted_122 = { class: "formcontainer upperspacing" }
const _hoisted_123 = { class: "row flex flex-row w-full" }
const _hoisted_124 = { class: "w-3/6" }
const _hoisted_125 = { class: "w-3/6 leftspacing" }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { key: 2 }
const _hoisted_128 = { class: "evidence-tab-content" }
const _hoisted_129 = { class: "evidence-files-block" }
const _hoisted_130 = { class: "border-b border-lightgrey flex justify-between paddingAdjustment mb-5 mt-2" }
const _hoisted_131 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_132 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_133 = { class: "evidence-files-section" }
const _hoisted_134 = {
  key: 0,
  class: "flex mt-4 gap-4 flex-wrap"
}
const _hoisted_135 = { class: "pdf w-full rounded-sm" }
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 0,
  src: _imports_4,
  alt: ""
}
const _hoisted_138 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_139 = {
  key: 2,
  src: _imports_1,
  alt: ""
}
const _hoisted_140 = {
  key: 3,
  src: _imports_2,
  alt: ""
}
const _hoisted_141 = {
  key: 4,
  src: _imports_3,
  alt: ""
}
const _hoisted_142 = {
  key: 5,
  src: _imports_4,
  alt: ""
}
const _hoisted_143 = {
  key: 6,
  src: _imports_5,
  alt: ""
}
const _hoisted_144 = {
  key: 7,
  src: _imports_6,
  alt: ""
}
const _hoisted_145 = {
  key: 8,
  src: _imports_7,
  alt: ""
}
const _hoisted_146 = {
  key: 9,
  src: _imports_8,
  alt: ""
}
const _hoisted_147 = {
  key: 10,
  src: _imports_9,
  alt: ""
}
const _hoisted_148 = {
  key: 11,
  src: _imports_10,
  alt: ""
}
const _hoisted_149 = {
  key: 12,
  src: _imports_11,
  alt: ""
}
const _hoisted_150 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_151 = { class: "ml-2 pb-1" }
const _hoisted_152 = ["title"]
const _hoisted_153 = { class: "flex justify-between w-full" }
const _hoisted_154 = { class: "ml-2 fontSize10PX" }
const _hoisted_155 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = {
  key: 1,
  class: "text-xs text-placeholdergray mt-3"
}
const _hoisted_158 = { class: "evidence-links-section" }
const _hoisted_159 = { class: "border-b border-lightgrey flex justify-between paddingAdjustment mt-6" }
const _hoisted_160 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_161 = { class: "evidence-links-scroll" }
const _hoisted_162 = { class: "evidence-links-header" }
const _hoisted_163 = { class: "flex items-center" }
const _hoisted_164 = { class: "flex items-center" }
const _hoisted_165 = { class: "flex items-center" }
const _hoisted_166 = { class: "flex items-center" }
const _hoisted_167 = { class: "evidence-links-body" }
const _hoisted_168 = { key: 0 }
const _hoisted_169 = ["title"]
const _hoisted_170 = { class: "table-ellipsis" }
const _hoisted_171 = ["title"]
const _hoisted_172 = { class: "table-ellipsis" }
const _hoisted_173 = { class: "table-ellipsis" }
const _hoisted_174 = ["onClick", "title"]
const _hoisted_175 = { class: "evidence-links-col-action" }
const _hoisted_176 = ["onClick"]
const _hoisted_177 = { key: 1 }
const _hoisted_178 = { key: 3 }
const _hoisted_179 = { class: "border-b border-lightgrey flex justify-between paddingAdjustment mb-5 mt-2" }
const _hoisted_180 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_181 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_182 = { class: "comment-box w-full" }
const _hoisted_183 = { class: "my-3" }
const _hoisted_184 = {
  key: 0,
  class: "comments"
}
const _hoisted_185 = {
  key: 0,
  class: "initials"
}
const _hoisted_186 = {
  key: 1,
  class: "initials"
}
const _hoisted_187 = { class: "w-1/5" }
const _hoisted_188 = { class: "header" }
const _hoisted_189 = { class: "fontSize10PX" }
const _hoisted_190 = { class: "w-4/5 text-xs" }
const _hoisted_191 = { key: 4 }
const _hoisted_192 = { class: "border-b border-lightgrey flex justify-between paddingAdjustment mt-2" }
const _hoisted_193 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_194 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_195 = {
  key: 0,
  class: "initials"
}
const _hoisted_196 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_197 = {
  key: 2,
  class: "initials"
}
const _hoisted_198 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_199 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_200 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_201 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_202 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_203 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_204 = { key: 5 }
const _hoisted_205 = { class: "border-b border-lightgrey flex justify-between paddingAdjustment mt-2" }
const _hoisted_206 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_207 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_208 = { class: "flex" }
const _hoisted_209 = {
  key: 0,
  class: "initials"
}
const _hoisted_210 = {
  key: 1,
  class: "initials"
}
const _hoisted_211 = { class: "logContainer w-93" }
const _hoisted_212 = { class: "flex mt-1" }
const _hoisted_213 = {
  key: 0,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_214 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_215 = {
  key: 2,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_216 = {
  key: 3,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_217 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_218 = {
  key: 5,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_219 = {
  key: 6,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_220 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_221 = { key: 0 }
const _hoisted_222 = {
  key: 0,
  class: "flex"
}
const _hoisted_223 = { class: "text-xs" }
const _hoisted_224 = {
  key: 1,
  class: "flex"
}
const _hoisted_225 = { class: "mx-2 text-xs" }
const _hoisted_226 = {
  key: 2,
  class: "flex"
}
const _hoisted_227 = { class: "mx-2 text-xs" }
const _hoisted_228 = {
  key: 3,
  class: "flex"
}
const _hoisted_229 = { class: "mx-2 text-xs" }
const _hoisted_230 = {
  key: 4,
  class: "flex mt-2"
}
const _hoisted_231 = { class: "mx-2 text-xs" }
const _hoisted_232 = {
  key: 5,
  class: "flex mt-2"
}
const _hoisted_233 = { class: "mx-2 text-xs" }
const _hoisted_234 = {
  key: 6,
  class: "flex"
}
const _hoisted_235 = { class: "mx-2 text-xs" }
const _hoisted_236 = {
  key: 7,
  class: "flex"
}
const _hoisted_237 = { key: 0 }
const _hoisted_238 = { key: 1 }
const _hoisted_239 = {
  key: 2,
  class: "flex"
}
const _hoisted_240 = { class: "mx-2 text-xs text-justify" }
const _hoisted_241 = {
  key: 8,
  class: "flex items-center"
}
const _hoisted_242 = { class: "flex ml-4" }
const _hoisted_243 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_244 = { class: "m-3" }
const _hoisted_245 = { key: 0 }
const _hoisted_246 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_247 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_248 = { class: "flex flex-col" }
const _hoisted_249 = {
  key: 0,
  class: "bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2 mb-3"
}
const _hoisted_250 = {
  key: 1,
  disabled: "",
  type: "text",
  placeholder: "Status",
  class: "completedBox inputboxstyling mt-2",
  value: "Completed"
}
const _hoisted_251 = { key: 0 }
const _hoisted_252 = { class: "mt-2" }
const _hoisted_253 = { key: 1 }
const _hoisted_254 = { class: "mt-3" }
const _hoisted_255 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_256 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_257 = {
  key: 0,
  class: "mb-3 mt-4"
}
const _hoisted_258 = { class: "mt-3" }
const _hoisted_259 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_260 = { class: "mt-3" }
const _hoisted_261 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_262 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_263 = { class: "mt-3" }
const _hoisted_264 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_265 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_266 = { class: "mt-3" }
const _hoisted_267 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_268 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_269 = { key: 2 }
const _hoisted_270 = { key: 3 }
const _hoisted_271 = { key: 4 }
const _hoisted_272 = { key: 0 }
const _hoisted_273 = {
  key: 5,
  class: "mt-2 text-sm"
}
const _hoisted_274 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_275 = { class: "relative w-full max-w-xl" }
const _hoisted_276 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_277 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_278 = { class: "flex flex-col h-full" }
const _hoisted_279 = { class: "flex-1 overflow-auto" }
const _hoisted_280 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_281 = { class: "formcontainer flex flex-col" }
const _hoisted_282 = { class: "row flex flex-col mt-2" }
const _hoisted_283 = { class: "controllabel" }
const _hoisted_284 = ["placeholder"]
const _hoisted_285 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_286 = {
  key: 0,
  class: "error-text"
}
const _hoisted_287 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_288 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_289 = {
  key: 0,
  class: "text-sm font-semibold text-darkblue mb-4"
}
const _hoisted_290 = {
  key: 1,
  class: "text-sm font-semibold text-primary mb-4"
}
const _hoisted_291 = { class: "flex items-center justify-center gap-2" }
const _hoisted_292 = ["disabled"]
const _hoisted_293 = { class: "min-h-[22px] text-red-500" }
const _hoisted_294 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_295 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_296 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_297 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_298 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_299 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_300 = { class: "pt-3 w-1/2" }
const _hoisted_301 = ["max"]
const _hoisted_302 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_303 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_304 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_305 = ["disabled"]
const _hoisted_306 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_307 = { class: "flex flex-col h-full" }
const _hoisted_308 = { class: "flex-1 overflow-auto" }
const _hoisted_309 = { class: "popup-business" }
const _hoisted_310 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_311 = { class: "formcontainer flex flex-col" }
const _hoisted_312 = { class: "row flex flex-row mt-2" }
const _hoisted_313 = { class: "w-1/2" }
const _hoisted_314 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_315 = {
  key: 0,
  class: "error-text"
}
const _hoisted_316 = { class: "row flex flex-row upperspacing" }
const _hoisted_317 = { class: "w-full" }
const _hoisted_318 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_319 = {
  key: 0,
  class: "error-text"
}
const _hoisted_320 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_321 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_322 = ["disabled"]
const _hoisted_323 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_324 = { class: "flex flex-col h-full" }
const _hoisted_325 = { class: "flex-1 overflow-auto" }
const _hoisted_326 = { class: "popup-business" }
const _hoisted_327 = { class: "statuscontainer px-4 py-4" }
const _hoisted_328 = { class: "formcontainer flex flex-col w-full" }
const _hoisted_329 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_330 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_331 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_332 = ["disabled"]
const _hoisted_333 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_334 = { class: "flex flex-col h-full" }
const _hoisted_335 = { class: "flex-1 overflow-auto" }
const _hoisted_336 = { class: "popup-business" }
const _hoisted_337 = { class: "statuscontainer px-4 py-4" }
const _hoisted_338 = { class: "formcontainer flex flex-col w-full" }
const _hoisted_339 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_340 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_341 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_342 = ["disabled"]
const _hoisted_343 = {
  key: 5,
  class: "evidence-delete-confirm"
}
const _hoisted_344 = { class: "evidence-delete-dialog" }
const _hoisted_345 = { class: "evidence-delete-dialog-actions" }
const _hoisted_346 = {
  key: 6,
  class: "link-existing-confirm"
}
const _hoisted_347 = { class: "link-existing-dialog" }
const _hoisted_348 = { class: "link-existing-tables" }
const _hoisted_349 = { class: "link-existing-section-row" }
const _hoisted_350 = { class: "link-existing-section" }
const _hoisted_351 = { class: "link-existing-table" }
const _hoisted_352 = { class: "flex table-header-label-wrap" }
const _hoisted_353 = { class: "flex table-header-label-wrap" }
const _hoisted_354 = { class: "flex table-header-label-wrap" }
const _hoisted_355 = { class: "flex table-header-label-wrap" }
const _hoisted_356 = {
  key: 0,
  class: "link-existing-filter-row"
}
const _hoisted_357 = { key: 0 }
const _hoisted_358 = { class: "link-existing-col-check" }
const _hoisted_359 = ["checked", "onChange"]
const _hoisted_360 = ["title"]
const _hoisted_361 = { key: 1 }
const _hoisted_362 = { class: "link-existing-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.presentFindingTaskObj.action), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      ((_ctx.presentFindingTaskObj.reviewer == _ctx.userInfo._id|| _ctx.userInfo?.role_id!=10217) && ( _ctx.presentFindingTaskObj.statusCode == 10421))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btnprimary items-center btnPrimaryPadding mr-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrRejectForActionTasktoComplete(10403,9)))
            }, "Approve"),
            _createElementVNode("button", {
              class: "btnprimary items-center btnPrimaryPadding",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickToRejectByJustificationAtInReview()))
            }, "Reject")
          ]))
        : _createCommentVNode("", true),
      (_ctx.presentFindingTaskObj.approvals!= undefined && _ctx.presentFindingTaskObj.approvals[_ctx.presentFindingTaskObj.approvals.length - 1].statusCode== 10401 && (_ctx.presentFindingTaskObj.approvals[_ctx.presentFindingTaskObj.approvals.length - 1].approver == _ctx.userInfo._id || _ctx.userInfo?.role_id!=10217))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btnprimary items-center btnPrimaryPadding mr-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ApprovalforInprogress(10403)))
            }, "Approve"),
            _createElementVNode("button", {
              class: "btnprimary items-center btnPrimaryPadding",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickToRejectByJustification()))
            }, "Reject")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Tabs, {
              value: _ctx.selectedTabIndex,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
              scrollable: "",
              class: "w-80 heightFixing pr-5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_TabList, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                        return (_openBlock(), _createBlock(_component_Tab, {
                          key: tab.id,
                          value: tab.id,
                          onClick: ($event: any) => (_ctx.toggleTabs(tab))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                      return (_openBlock(), _createBlock(_component_TabPanel, {
                        key: tab.id,
                        value: tab.id
                      }, {
                        default: _withCtx(() => [
                          (_ctx.tabDataLoading == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_dots_loader)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  (tab.id == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("div", null, [
                                          _cache[109] || (_cache[109] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings" }, [
                                              _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "header mt-2.5" }, "Action Information")
                                                ])
                                              ])
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_15, [
                                            _cache[74] || (_cache[74] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, " Cause ", -1)),
                                            _createElementVNode("div", _hoisted_16, _toDisplayString((_ctx.presentFindingTaskObj.cause != undefined ? _ctx.presentFindingTaskObj.cause : 'N/A')), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_17, [
                                            _cache[75] || (_cache[75] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, " Action ", -1)),
                                            _createElementVNode("div", _hoisted_18, _toDisplayString((_ctx.presentFindingTaskObj.action != undefined ? _ctx.presentFindingTaskObj.action : 'N/A')), 1)
                                          ]),
                                          _cache[110] || (_cache[110] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings" }, [
                                              _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "header mt-2.5" }, "Finding Information")
                                                ])
                                              ])
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_19, [
                                            _cache[76] || (_cache[76] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-1/4 border-lightgrey rounded-tl-md" }, " Finding ID ", -1)),
                                            _createElementVNode("div", _hoisted_20, _toDisplayString(String(_ctx.findingDetails[0].id).toUpperCase()||'N/A'), 1),
                                            _cache[77] || (_cache[77] = _createElementVNode("div", { class: "border-t border-b border-l p-2 header w-1/4 border-lightgrey" }, " CR ID ", -1)),
                                            _createElementVNode("div", _hoisted_21, _toDisplayString(String(_ctx.presentFindingTaskObj.complianceReviewId).toUpperCase()), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getFindingRelatedToFieldLabel(_ctx.findingDetails[0])), 1),
                                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getFindingRelatedToDisplay(_ctx.findingDetails[0])), 1),
                                            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.getFindingLinkFieldLabel(_ctx.findingDetails[0])), 1),
                                            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getFindingLinkDisplay(_ctx.findingDetails[0])), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_27, [
                                            _cache[78] || (_cache[78] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, " Finding ", -1)),
                                            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.findingDetails[0].name||'N/A'), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_29, [
                                            _cache[80] || (_cache[80] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey flex items-center" }, " Evidence ", -1)),
                                            _createElementVNode("div", _hoisted_30, [
                                              (_ctx.findingDetailFileEvidences.length || _ctx.findingDetailLinkEvidences.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingDetailFileEvidences, (doc, idx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 'finding-detail-file-'+idx
                                                      }, [
                                                        _createElementVNode("div", _hoisted_32, [
                                                          _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                            class: "flex w-full flex-row items-center cursor-pointer"
                                                          }, [
                                                            ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_37))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='png')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_47, [
                                                              _createElementVNode("div", _hoisted_48, [
                                                                _createElementVNode("p", {
                                                                  class: "text-xs font-medium truncate",
                                                                  title: doc.filename || doc.name
                                                                }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_49)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_50, [
                                                                _createElementVNode("p", _hoisted_51, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                _createElementVNode("p", _hoisted_52, _toDisplayString(doc.linkedEvidenceTaskId ? (_ctx.presentFindingTaskObj.taskId || 'N/A') : (doc.taskId ? doc.taskId : 'N/A')), 1)
                                                              ])
                                                            ])
                                                          ], 8, _hoisted_33)
                                                        ])
                                                      ]))
                                                    }), 128)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingDetailLinkEvidences, (doc, idx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 'finding-detail-link-'+idx
                                                      }, [
                                                        _createElementVNode("div", _hoisted_53, [
                                                          _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                            class: "finding-evidence-link-icon cursor-pointer",
                                                            "aria-label": doc.url
                                                          }, [
                                                            _createElementVNode("span", _hoisted_55, [
                                                              _cache[79] || (_cache[79] = _createElementVNode("img", {
                                                                src: _imports_12,
                                                                alt: "Link",
                                                                class: "finding-evidence-link-icon__img"
                                                              }, null, -1)),
                                                              _createElementVNode("span", _hoisted_56, _toDisplayString(doc.url), 1)
                                                            ])
                                                          ], 8, _hoisted_54),
                                                          _createElementVNode("div", _hoisted_57, [
                                                            _createElementVNode("div", _hoisted_58, [
                                                              _createElementVNode("p", {
                                                                class: "text-xs font-medium truncate",
                                                                title: doc.filename || doc.name
                                                              }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_59)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_60, [
                                                              _createElementVNode("p", _hoisted_61, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                              _createElementVNode("p", _hoisted_62, _toDisplayString(doc.linkedEvidenceTaskId ? (_ctx.presentFindingTaskObj.taskId || 'N/A') : (doc.taskId ? doc.taskId : 'N/A')), 1)
                                                            ])
                                                          ])
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_63, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_64, [
                                            _cache[81] || (_cache[81] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md flex items-center" }, " Finding Severity ", -1)),
                                            _createElementVNode("div", _hoisted_65, [
                                              (_ctx.getFindingSeverityValue(_ctx.findingDetails[0]) != null)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.findingSeverityChipBg(_ctx.findingDetails[0])]),
                                                    title: _ctx.getFindingSeverityLabel(_ctx.findingDetails[0])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText(_ctx.findingDetails[0])])
                                                    }, _toDisplayString(_ctx.getFindingSeverityLabel(_ctx.findingDetails[0])), 3)
                                                  ], 10, _hoisted_66))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_67, "N/A"))
                                            ])
                                          ]),
                                          (_ctx.presentFindingTaskObj.appId!=undefined && _ctx.presentFindingTaskObj?.appId==10003)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                _createElementVNode("div", null, [
                                                  _cache[92] || (_cache[92] = _createElementVNode("div", null, [
                                                    _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                      _createElementVNode("p", { class: "mt-4 mb-1.5 header" }, "Risk Information")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("div", _hoisted_69, [
                                                    _createElementVNode("div", _hoisted_70, [
                                                      _cache[82] || (_cache[82] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Risk", -1)),
                                                      ((_ctx.presentFindingTaskObj?.risk||'N/A'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(_ctx.presentFindingTaskObj?.risk ||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_72, "N/A"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_73, [
                                                      _cache[83] || (_cache[83] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Priority", -1)),
                                                      (_ctx.presentFindingTaskObj?.priority && typeof _ctx.presentFindingTaskObj?.priority === 'number')
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentFindingTaskObj?.priority)])
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentFindingTaskObj?.priority)])
                                                            }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentFindingTaskObj?.priority)), 3)
                                                          ], 2))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_74, "N/A"))
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("div", _hoisted_76, [
                                                      _cache[84] || (_cache[84] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Category", -1)),
                                                      ((_ctx.presentFindingTaskObj?.riskCategory))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.presentFindingTaskObj?.riskCategory||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_78, "N/A"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_79, [
                                                      _cache[85] || (_cache[85] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Owner", -1)),
                                                      ((_ctx.presentFindingTaskObj?.riskOwner))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(_ctx.getRiskOwnerLabel(_ctx.presentFindingTaskObj?.riskOwner)||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_81, "N/A"))
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_82, [
                                                    _createElementVNode("div", _hoisted_83, [
                                                      _cache[86] || (_cache[86] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Category", -1)),
                                                      ((_ctx.presentFindingTaskObj?.threatCategory))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_84, _toDisplayString(_ctx.presentFindingTaskObj?.threatCategory||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_85, "N/A"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_86, [
                                                      _cache[87] || (_cache[87] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Source", -1)),
                                                      ((_ctx.presentFindingTaskObj?.threatSource))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_ctx.presentFindingTaskObj?.threatSource||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_88, "N/A"))
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_89, [
                                                    _cache[88] || (_cache[88] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat", -1)),
                                                    ((_ctx.presentFindingTaskObj?.threatEvent))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.presentFindingTaskObj?.threatEvent||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_91, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_92, [
                                                    _cache[89] || (_cache[89] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Vulnerability", -1)),
                                                    ((_ctx.presentFindingTaskObj?.vulnerability))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(_ctx.presentFindingTaskObj?.vulnerability||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_94, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_95, [
                                                    _cache[90] || (_cache[90] = _createElementVNode("p", { class: "font-extrabold mb-2 text-xs" }, "Risk Assessment", -1)),
                                                    ((_ctx.presentFindingTaskObj?.riskAssessment!=''))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString(_ctx.presentFindingTaskObj?.riskAssessment||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_97, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_98, [
                                                    _cache[91] || (_cache[91] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Treatment Summary", -1)),
                                                    ((_ctx.presentFindingTaskObj?.treatmentType!=''))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(_ctx.treatmentSummaryData(_ctx.presentFindingTaskObj?.treatmentType)||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_100, "N/A"))
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _cache[99] || (_cache[99] = _createElementVNode("h1", { class: "upperspacing" }, "Inherited Risk", -1)),
                                                  _cache[100] || (_cache[100] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                                  _createElementVNode("div", _hoisted_101, [
                                                    _createElementVNode("div", _hoisted_102, [
                                                      _createElementVNode("div", _hoisted_103, [
                                                        _cache[93] || (_cache[93] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.business)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.business))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.business,1)||'N/A'), 3)
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_104, [
                                                        _cache[94] || (_cache[94] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.financial)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.financial))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.financial,2)||'N/A'), 3)
                                                        ], 2)
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_105, [
                                                    _createElementVNode("div", _hoisted_106, [
                                                      _createElementVNode("div", _hoisted_107, [
                                                        _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.operations)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.operations))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.operations,3)||'N/A'), 3)
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_108, [
                                                        _cache[96] || (_cache[96] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.legal)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.legal))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.legal,4)||'N/A'), 3)
                                                        ], 2)
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_109, [
                                                    _createElementVNode("div", _hoisted_110, [
                                                      _createElementVNode("div", _hoisted_111, [
                                                        _cache[97] || (_cache[97] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.likelihood)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.likelihood))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.likelihood,5)||'N/A'), 3)
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_112, [
                                                        _cache[98] || (_cache[98] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.overallImpact)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.overallImpact))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.overallImpact,6)||'N/A'), 3)
                                                        ], 2)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                (_ctx.presentFindingTaskObj?.treatmentType && _ctx.presentFindingTaskObj?.treatmentType!=10419)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                      _cache[107] || (_cache[107] = _createElementVNode("h1", { class: "upperspacing" }, "Residual Risk", -1)),
                                                      _cache[108] || (_cache[108] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                                      _createElementVNode("div", _hoisted_114, [
                                                        _createElementVNode("div", _hoisted_115, [
                                                          _createElementVNode("div", _hoisted_116, [
                                                            _cache[101] || (_cache[101] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.residual?.[0]?.business)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.residual?.[0]?.business))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.residual?.[0]?.business,1)||'N/A'), 3)
                                                            ], 2)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_117, [
                                                            _cache[102] || (_cache[102] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.residual?.[0]?.financial)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.residual?.[0]?.financial))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.residual?.[0]?.financial,2)||'N/A'), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_118, [
                                                        _createElementVNode("div", _hoisted_119, [
                                                          _createElementVNode("div", _hoisted_120, [
                                                            _cache[103] || (_cache[103] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.residual?.[0]?.operations)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.residual?.[0]?.operations))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.residual?.[0]?.operations,3)||'N/A'), 3)
                                                            ], 2)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_121, [
                                                            _cache[104] || (_cache[104] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.residual?.[0]?.legal)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.residual?.[0]?.legal))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.residual?.[0]?.legal,4)||'N/A'), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_122, [
                                                        _createElementVNode("div", _hoisted_123, [
                                                          _createElementVNode("div", _hoisted_124, [
                                                            _cache[105] || (_cache[105] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.residual?.[0]?.likelihood)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.residual?.[0]?.likelihood))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.residual?.[0]?.likelihood,5)||'N/A'), 3)
                                                            ], 2)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_125, [
                                                            _cache[106] || (_cache[106] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingTaskObj?.overallImpact)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingTaskObj?.overallImpact))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingTaskObj?.overallImpact,6)||'N/A'), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, _cache[111] || (_cache[111] = [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings" }, [
                                              _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "header mt-2.5" }, "Documents which are related to the controls")
                                                ])
                                              ])
                                            ])
                                          ])
                                        ], -1)
                                      ])))
                                    : _createCommentVNode("", true),
                                  (tab.id == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                        _createElementVNode("div", _hoisted_128, [
                                          _createElementVNode("div", _hoisted_129, [
                                            _createElementVNode("div", _hoisted_130, [
                                              _cache[112] || (_cache[112] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "header" }, "Files")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_131, [
                                                  _createElementVNode("div", _hoisted_132, [
                                                    _createElementVNode("button", {
                                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openLinkEvidencePopup && _ctx.openLinkEvidencePopup(...args))),
                                                      class: _normalizeClass([_ctx.isEvidenceAttachDisabled() ? 'btndisabled borderForBtndisabled pointer-events-none mr-3' : 'filterButton flex justify-center mr-3', "flex justify-center"])
                                                    }, " Link Existing ", 2),
                                                    _createElementVNode("button", {
                                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openFilePopup('file'))),
                                                      for: "upload",
                                                      class: _normalizeClass([
                                        _ctx.TaskDetailsDropDown.taskStatus == 10403 ||
                                        _ctx.TaskDetailsDropDown.taskStatus == 10417 ||
                                        _ctx.presentComplianceObject.statusCode == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10418 ||
                                        _ctx.presentComplianceObject.statusCode == 10418 || _ctx.presentFindingTaskObj.reviewer == _ctx.userInfo._id && (_ctx.userInfo?.role_id==10215 && _ctx.userInfo?.roleId==10215) || !_ctx.isAddDisabled(10302)
                                          ? 'btndisabled borderForBtndisabled pointer-events-none'
                                          : 'filterButton flex justify-center'
                                      , "flex justify-center"])
                                                    }, " Attach ", 2)
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_133, [
                                              (_ctx.fileEvidences.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileEvidences, (doc, idx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 'file-'+idx
                                                      }, [
                                                        _createElementVNode("div", _hoisted_135, [
                                                          _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                            class: "flex w-full flex-row items-center cursor-pointer"
                                                          }, [
                                                            ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_137))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_138))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_139))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_140))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_141))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_142))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_143))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='png')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_144))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_145))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_146))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_147))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_148))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_149))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_150, [
                                                              _createElementVNode("div", _hoisted_151, [
                                                                _createElementVNode("p", {
                                                                  class: "text-xs font-medium truncate",
                                                                  title: doc.filename || doc.name
                                                                }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_152)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_153, [
                                                                _createElementVNode("p", _hoisted_154, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                _createElementVNode("p", _hoisted_155, _toDisplayString(doc.linkedEvidenceTaskId ? (_ctx.presentFindingTaskObj.taskId || 'N/A') : (doc.taskId ? doc.taskId : 'N/A')), 1)
                                                              ])
                                                            ]),
                                                            (!_ctx.isPlannerCreatedEvidence(doc))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 13,
                                                                  type: "button",
                                                                  class: _normalizeClass(["evidence-file-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                  onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentFindingTaskObj.files.indexOf(doc))), ["stop","prevent"])
                                                                }, _cache[113] || (_cache[113] = [
                                                                  _createElementVNode("img", {
                                                                    src: _imports_13,
                                                                    alt: "Delete"
                                                                  }, null, -1)
                                                                ]), 10, _hoisted_156))
                                                              : _createCommentVNode("", true)
                                                          ], 8, _hoisted_136)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_157, "No files attached"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_158, [
                                            _createElementVNode("div", _hoisted_159, [
                                              _cache[114] || (_cache[114] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("p", { class: "header" }, "Links")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_160, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openFilePopup('url'))),
                                                  class: _normalizeClass([
                                      _ctx.TaskDetailsDropDown.taskStatus == 10403 ||
                                      _ctx.TaskDetailsDropDown.taskStatus == 10417 ||
                                      _ctx.presentComplianceObject.statusCode == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10418 ||
                                      _ctx.presentComplianceObject.statusCode == 10418 || _ctx.presentFindingTaskObj.reviewer == _ctx.userInfo._id && (_ctx.userInfo?.role_id==10215 && _ctx.userInfo?.roleId==10215) || !_ctx.isAddDisabled(10302)
                                        ? 'btndisabled borderForBtndisabled pointer-events-none'
                                        : 'filterButton flex justify-center'
                                    , "flex justify-center"])
                                                }, " Add Link ", 2)
                                              ])
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["evidence-links-wrap", { 'evidence-links-wrap--empty': _ctx.filteredLinkCount === 0 }])
                                            }, [
                                              _createElementVNode("div", _hoisted_161, [
                                                _createElementVNode("div", _hoisted_162, [
                                                  _createElementVNode("table", {
                                                    class: "evidence-links-table",
                                                    style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                  }, [
                                                    _createElementVNode("thead", null, [
                                                      _createElementVNode("tr", null, [
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-id resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('taskId')),
                                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onLinkHeaderClick('taskId')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_163, [
                                                            _cache[115] || (_cache[115] = _createElementVNode("div", null, "ID", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'taskId' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'taskId')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-title resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('filename')),
                                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onLinkHeaderClick('filename')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_164, [
                                                            _cache[116] || (_cache[116] = _createElementVNode("div", null, "Link Title", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'filename' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'filename')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-link resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('url')),
                                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onLinkHeaderClick('url')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_165, [
                                                            _cache[117] || (_cache[117] = _createElementVNode("div", null, "Link", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'url' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'url')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-date resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('evidenceDate')),
                                                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onLinkHeaderClick('evidenceDate')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_166, [
                                                            _cache[118] || (_cache[118] = _createElementVNode("div", null, "Evidence Date", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'evidenceDate' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'evidenceDate')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _cache[119] || (_cache[119] = _createElementVNode("th", { class: "evidence-links-col-action" }, null, -1))
                                                      ])
                                                    ])
                                                  ], 4)
                                                ]),
                                                _createElementVNode("div", _hoisted_167, [
                                                  _createElementVNode("table", {
                                                    class: "evidence-links-table",
                                                    style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                  }, [
                                                    (_ctx.paginatedLinkEvidences.length)
                                                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_168, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLinkEvidences, (doc, idx) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: 'link-'+idx,
                                                              class: "rowHeight evidence-links-row"
                                                            }, [
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-id",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('taskId')),
                                                                title: doc.linkedEvidenceTaskId ? (_ctx.presentFindingTaskObj.taskId || 'N/A') : (doc.taskId || 'N/A')
                                                              }, [
                                                                _createElementVNode("div", _hoisted_170, _toDisplayString(doc.linkedEvidenceTaskId ? (_ctx.presentFindingTaskObj.taskId || 'N/A') : (doc.taskId || 'N/A')), 1)
                                                              ], 12, _hoisted_169),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-title",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('filename')),
                                                                title: doc.filename || doc.name
                                                              }, [
                                                                _createElementVNode("div", _hoisted_172, _toDisplayString(doc.filename || doc.name || 'N/A'), 1)
                                                              ], 12, _hoisted_171),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-link",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('url'))
                                                              }, [
                                                                _createElementVNode("div", _hoisted_173, [
                                                                  _createElementVNode("a", {
                                                                    href: "#",
                                                                    class: "text-primary evidence-link-anchor cursor-pointer",
                                                                    onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                    title: doc.url
                                                                  }, _toDisplayString(doc.url), 9, _hoisted_174)
                                                                ])
                                                              ], 4),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-date",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('evidenceDate'))
                                                              }, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 5),
                                                              _createElementVNode("td", _hoisted_175, [
                                                                (!_ctx.isPlannerCreatedEvidence(doc))
                                                                  ? (_openBlock(), _createElementBlock("button", {
                                                                      key: 0,
                                                                      type: "button",
                                                                      class: _normalizeClass(["evidence-links-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                      onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentFindingTaskObj.files.indexOf(doc))), ["stop","prevent"])
                                                                    }, _cache[120] || (_cache[120] = [
                                                                      _createElementVNode("img", {
                                                                        src: _imports_13,
                                                                        alt: "Delete",
                                                                        class: "h-5 w-5"
                                                                      }, null, -1)
                                                                    ]), 10, _hoisted_176))
                                                                  : _createCommentVNode("", true)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("tbody", _hoisted_177, _cache[121] || (_cache[121] = [
                                                          _createElementVNode("tr", null, [
                                                            _createElementVNode("td", {
                                                              class: "evidence-links-empty",
                                                              colspan: "5"
                                                            }, [
                                                              _createElementVNode("div", { class: "flex justify-center" }, [
                                                                _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                              ])
                                                            ])
                                                          ], -1)
                                                        ])))
                                                  ], 4)
                                                ])
                                              ]),
                                              (_ctx.filteredLinkCount > 0)
                                                ? (_openBlock(), _createBlock(_component_pagination, {
                                                    key: 0,
                                                    dynamicPagination: _ctx.filteredLinkCount,
                                                    sortedData: _ctx.sortedLinkEvidences,
                                                    onCurrentPageUpdate: _ctx.onLinkPaginationUpdate
                                                  }, null, 8, ["dynamicPagination", "sortedData", "onCurrentPageUpdate"]))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                        _createElementVNode("div", _hoisted_179, [
                                          _cache[124] || (_cache[124] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "header" }, "Comments")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_180, [
                                              _createElementVNode("div", _hoisted_181, [
                                                (_ctx.oldComments)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: _normalizeClass(["filterButton flex", Object.keys(this.presentFindingTaskObj).includes('comments') && this.presentFindingTaskObj.comments.length != 0 ? 'filterButton' : 'pointer-events-none']),
                                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortComments()))
                                                    }, _cache[122] || (_cache[122] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_14,
                                                        class: "h-3 mr-2.5"
                                                      }, null, -1),
                                                      _createTextVNode(" Oldest ")
                                                    ]), 2))
                                                  : _createCommentVNode("", true),
                                                (!_ctx.oldComments)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      class: "filterButton flex",
                                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortComments()))
                                                    }, _cache[123] || (_cache[123] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_14,
                                                        class: "h-3 mr-2.5 rotate-180"
                                                      }, null, -1),
                                                      _createTextVNode(" Newest ")
                                                    ])))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_182, [
                                            _createElementVNode("div", _hoisted_183, [
                                              (_ctx.TaskDetailsDropDown.taskStatus!=10403 && _ctx.TaskDetailsDropDown.taskStatus!=10418 && _ctx.TaskDetailsDropDown.taskStatus!=10417 &&_ctx.isAddDisabled(10302))
                                                ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                                    key: 0,
                                                    taskStatusCode: _ctx.TaskDetailsDropDown.taskStatus
                                                  }, null, 8, ["taskStatusCode"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          (Object.keys(_ctx.presentFindingTaskObj).includes('comments'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingTaskObj.comments, (obj, index) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-2",
                                                    key: index
                                                  }, [
                                                    (Object.keys(obj).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_185, _toDisplayString(_ctx.extractInitials(obj.name)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(obj).includes('updatedBy'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, _toDisplayString(_ctx.extractInitials(obj.name)), 1))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_187, [
                                                      _createElementVNode("div", _hoisted_188, _toDisplayString(obj.name), 1),
                                                      _createElementVNode("div", _hoisted_189, _toDisplayString(obj.createdAt), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_190, [
                                                      _createVNode(_component_safeHtml, {
                                                        content: obj.comment
                                                      }, null, 8, ["content"])
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_192, [
                                            _cache[125] || (_cache[125] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "Approvals")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_193, [
                                                _createElementVNode("div", _hoisted_194, [
                                                  _createElementVNode("button", {
                                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openApprovalpopup())),
                                                    class: _normalizeClass([(_ctx.newAssignee.value != _ctx.userInfo._id  && _ctx.presentFindingTaskObj.teamOwner != _ctx.userInfo._id && _ctx.userInfo?.role_id==10217) || _ctx.TaskDetailsDropDown.taskStatus == 10418 || _ctx.TaskDetailsDropDown.taskStatus ==10414 || _ctx.approvalObj.statusCode == 10401 || _ctx.presentFindingTaskObj.statusCode == 10403 || (_ctx.presentFindingTaskObj.teamOwner != _ctx.userInfo._id &&( _ctx.presentFindingTaskObj.assignee != undefined && (_ctx.presentFindingTaskObj.assignee.value != _ctx.userInfo._id && _ctx.userInfo?.role_id==10217))) || !_ctx.isAddDisabled(10302) ?'btndisabled pointer-events-none' : 'filterButton flex justify-center', "flex justify-center"])
                                                  }, "Send Approval", 2)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingTaskObj.approvals, (approval, number) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: number,
                                                class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                              }, [
                                                (approval.createdBy != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_195, _toDisplayString(_ctx.extractInitials(approval.name)), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.createdBy != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString(approval.name), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.updatedBy != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_197, _toDisplayString(_ctx.extractInitials(approval.name)), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.updatedBy != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_198, _toDisplayString(approval.name), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.statusCode == 10401)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString(' Requested an approval ')))
                                                  : _createCommentVNode("", true),
                                                (approval.statusCode == 10410)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, _toDisplayString(' Rejected an approval ')))
                                                  : (approval.statusCode == 10403)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_201, _toDisplayString(' Approved an approval ')))
                                                    : _createCommentVNode("", true),
                                                (approval.createdAt != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_202, _toDisplayString(approval.createdAt), 1))
                                                  : _createCommentVNode("", true),
                                                (approval.updatedAt != undefined)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_203, _toDisplayString(approval.updatedAt), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 6)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_205, [
                                            _cache[128] || (_cache[128] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "History")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_206, [
                                                _createElementVNode("div", _hoisted_207, [
                                                  (_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: _normalizeClass(["filterButton flex", Object.keys(this.workLogObject).includes('taskHistory') && this.workLogObject.taskHistory.length != 0 ? 'filterButton' : ' pointer-events-none']),
                                                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[126] || (_cache[126] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_14,
                                                          class: "h-3 mr-2.5"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ")
                                                      ]), 2))
                                                    : _createCommentVNode("", true),
                                                  (!_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "filterButton flex",
                                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, _cache[127] || (_cache[127] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_14,
                                                          class: "h-3 mr-2.5 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ")
                                                      ])))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: work,
                                                class: "bg-white py-4 mb-0.5 border-lightgrey border-b w-full"
                                              }, [
                                                _createElementVNode("div", _hoisted_208, [
                                                  (_ctx.checkKey(work,'createdBy'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_209, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                    : _createCommentVNode("", true),
                                                  (Object.keys(work).includes('updatedBy'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_210, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_211, [
                                                    _createElementVNode("div", _hoisted_212, [
                                                      (Object.keys(work).includes('createdBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_213, _toDisplayString(work.name), 1))
                                                        : (Object.keys(work).includes('updatedBy'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_214, _toDisplayString(work.name), 1))
                                                          : _createCommentVNode("", true),
                                                      (work.actionEntity == 10301)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_215, _toDisplayString('Created the Task on')))
                                                        : (work.statusCode != undefined && work.statusCode == 10418)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_216, _toDisplayString('Terminated the Task on')))
                                                          : (work.actionEntity == 10302)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_217, _toDisplayString('Updated the Task on')))
                                                            : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('createdAt'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_218, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('updatedAt'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_219, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    (Object.keys(work).includes('additionalInfo'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                                          (work.additionalInfo)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                                                (_ctx.checkKey(work.additionalInfo,'comment'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                                                                      _cache[129] || (_cache[129] = _createElementVNode("div", { class: "font-semibold text-xs" }, "Comment:", -1)),
                                                                      _createElementVNode("div", _hoisted_223, [
                                                                        _createVNode(_component_safeHtml, {
                                                                          content: work.additionalInfo.comment
                                                                        }, null, 8, ["content"])
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                                                      _cache[130] || (_cache[130] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                                      _createElementVNode("p", _hoisted_225, _toDisplayString(work.additionalInfo.evidence), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (work.additionalInfo.removed)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                                                      _cache[131] || (_cache[131] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Deleted the Evidence -'), -1)),
                                                                      _createElementVNode("p", _hoisted_227, _toDisplayString(work.additionalInfo.evidence), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('linkedEvidenceTitles'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                                                      _cache[132] || (_cache[132] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked the Evidence -'), -1)),
                                                                      _createElementVNode("p", _hoisted_229, _toDisplayString(work.additionalInfo.linkedEvidenceTitles), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('linkedEvidenceDates'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                                                                      _cache[133] || (_cache[133] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked Evidence Date -'), -1)),
                                                                      _createElementVNode("p", _hoisted_231, _toDisplayString(work.additionalInfo.linkedEvidenceDates), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('evidenceDate'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                                                      _cache[134] || (_cache[134] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                                      _createElementVNode("p", _hoisted_233, _toDisplayString(_ctx.formatDate(work.additionalInfo.evidenceDate)||'N/A'), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('assignee'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                                                      _cache[135] || (_cache[135] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                                      _createElementVNode("p", _hoisted_235, _toDisplayString(work.additionalInfo.name), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('approver'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                                                                      (work.additionalInfo.action == 10301)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_237, _cache[136] || (_cache[136] = [
                                                                            _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Sent Approval for -'), -1)
                                                                          ])))
                                                                        : _createCommentVNode("", true),
                                                                      (work.additionalInfo.statusCode == 10403)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_238, _cache[137] || (_cache[137] = [
                                                                            _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Approved Approval -'), -1)
                                                                          ])))
                                                                        : _createCommentVNode("", true),
                                                                      (work.additionalInfo.statusCode == 10410)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_239, _cache[138] || (_cache[138] = [
                                                                            _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Rejected Approval -'), -1)
                                                                          ])))
                                                                        : _createCommentVNode("", true),
                                                                      _createElementVNode("p", _hoisted_240, _toDisplayString(work.additionalInfo.name), 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                                                      _cache[140] || (_cache[140] = _createElementVNode("div", null, [
                                                                        _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated the status :'))
                                                                      ], -1)),
                                                                      _createElementVNode("div", _hoisted_242, [
                                                                        _createElementVNode("div", {
                                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.previousStatus)])
                                                                        }, [
                                                                          _createElementVNode("div", {
                                                                            class: _normalizeClass(_ctx.colorFindingText(work.additionalInfo.previousStatus))
                                                                          }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                        ], 2),
                                                                        _cache[139] || (_cache[139] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                          _createElementVNode("img", { src: _imports_15 })
                                                                        ], -1)),
                                                                        _createElementVNode("div", {
                                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.updatedStatus)])
                                                                        }, [
                                                                          _createElementVNode("div", {
                                                                            class: _normalizeClass(_ctx.colorFindingText(work.additionalInfo.updatedStatus))
                                                                          }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                        ], 2)
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_243, [
              _createElementVNode("div", _hoisted_244, [
                _cache[156] || (_cache[156] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                  _createElementVNode("h1", null, "Task Details")
                ], -1)),
                (_ctx.tabDataLoading == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                      _createElementVNode("div", _hoisted_246, [
                        _createVNode(_component_dots_loader)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_247, [
                      _createElementVNode("div", _hoisted_248, [
                        _cache[142] || (_cache[142] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                        _createElementVNode("div", null, [
                          (_ctx.TaskDetailsDropDown.taskStatus == 10418)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_249, _cache[141] || (_cache[141] = [
                                _createElementVNode("div", { class: "bg-error textColorWhite" }, _toDisplayString('Terminated'), -1)
                              ])))
                            : (_ctx.TaskDetailsDropDown.taskStatus == 10403)
                              ? (_openBlock(), _createElementBlock("input", _hoisted_250))
                              : _createCommentVNode("", true),
                          (_ctx.checkreviewer(_ctx.presentFindingTaskObj.reviewer) &&
                          (_ctx.TaskDetailsDropDown.taskStatus == 10414 ||
                            _ctx.TaskDetailsDropDown.taskStatus == 10421))
                            ? (_openBlock(), _createBlock(_component_Select, {
                                key: 2,
                                modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                options: _ctx.reviewerTask,
                                disabled:  !_ctx.isAddDisabled(10302),
                                appendTo: "body",
                                onChange: _ctx.onTaskStatusChange,
                                optionLabel: "value",
                                optionValue: "id",
                                class: _normalizeClass(["w-full mt-2", _ctx.changeBackground(),
                        _ctx.TaskDetailsDropDown.taskStatus == 10403?'completed-status-arrow':'custom-select']),
                                optionDisabled: _ctx.isOptionDisabled
                              }, null, 8, ["modelValue", "options", "disabled", "onChange", "class", "optionDisabled"]))
                            : (
                          !_ctx.checkreviewer(_ctx.presentFindingTaskObj.reviewer) &&
                          (_ctx.TaskDetailsDropDown.taskStatus == 10401 ||
                            _ctx.TaskDetailsDropDown.taskStatus == 10402 ||
                            _ctx.TaskDetailsDropDown.taskStatus == 10408 ||
                            _ctx.TaskDetailsDropDown.taskStatus == 10414))
                              ? (_openBlock(), _createBlock(_component_Select, {
                                  key: 3,
                                  modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                  options: _ctx.taskStatusInfo,
                                  disabled: 
                          _ctx.TaskDetailsDropDown.taskStatus == 10414 ||
                          _ctx.TaskDetailsDropDown.taskStatus == 10421 ||
                          _ctx.TaskDetailsDropDown.taskStatus == 10403  || !_ctx.isAddDisabled(10302)
                        ,
                                  appendTo: "body",
                                  onChange: _ctx.onTaskStatusChange,
                                  optionLabel: "value",
                                  optionValue: "id",
                                  class: _normalizeClass(["w-full border-solid border border-lightgrey mt-2", _ctx.changeBackground()]),
                                  optionDisabled: _ctx.isOptionDisabled
                                }, null, 8, ["modelValue", "options", "disabled", "onChange", "class", "optionDisabled"]))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          (
                          !_ctx.checkreviewer(_ctx.presentFindingTaskObj.reviewer) &&
                          _ctx.presentFindingTaskObj.statusCode == 10421)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([_ctx.changeBackground(), "inputboxstyling1 disabled cursor-pointer mt-2 mb-3"])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.changeBackground()),
                                  onChange: _cache[23] || (_cache[23] = ($event: any) => (
                            _ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                }, _toDisplayString(_ctx.reviewerTask.find((data) => {
                              return (
                                data.id == _ctx.presentFindingTaskObj.statusCode
                              );
                            }).value), 35)
                              ], 2))
                            : _createCommentVNode("", true),
                          (
                          _ctx.checkreviewer(_ctx.presentFindingTaskObj.reviewer) &&
                          (_ctx.TaskDetailsDropDown.taskStatus == 10401 ||
                            _ctx.TaskDetailsDropDown.taskStatus == 10402 ||
                            _ctx.TaskDetailsDropDown.taskStatus == 10408) )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([_ctx.changeBackground(), "inputboxstyling1 disabled cursor-pointer mt-2 mb-3"])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.changeBackground()),
                                  onChange: _cache[24] || (_cache[24] = ($event: any) => (
                            _ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                }, _toDisplayString(_ctx.taskStatusInfo.find((data) => {
                              return (
                                data.id == _ctx.presentFindingTaskObj.statusCode
                              );
                            }).value), 35)
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _cache[143] || (_cache[143] = _createElementVNode("label", { class: "controllabel" }, "Assignee", -1)),
                          (_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.presentFindingTaskObj.statusCode == 10403 || _ctx.presentFindingTaskObj.statusCode == 10418 || _ctx.presentFindingTaskObj.reviewer == _ctx.userInfo._id  || (_ctx.presentFindingTaskObj.teamOwner != _ctx.userInfo._id && ( _ctx.newAssignee.value != _ctx.userInfo._id)))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                                _createElementVNode("p", _hoisted_252, _toDisplayString(_ctx.newAssignee.label), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.presentFindingTaskObj.assignee,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.presentFindingTaskObj.assignee) = $event)),
                                  suggestions: _ctx.userOptions,
                                  onComplete: _ctx.asyncFind,
                                  onItemSelect: _cache[26] || (_cache[26] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentFindingTaskObj.assignee))),
                                  optionLabel: "label",
                                  optionValue: "value",
                                  forceSelection: true,
                                  placeholder: "Assigned-To",
                                  class: "p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect"
                                }, null, 8, ["modelValue", "suggestions", "onComplete"])
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_254, [
                        _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Reviewer", -1)),
                        _cache[145] || (_cache[145] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingTaskObj.reviewer != undefined || _ctx.presentFindingTaskObj.reviewer != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_255, _toDisplayString(_ctx.getPerson(_ctx.presentFindingTaskObj.reviewer)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_256, "N/A"))
                      ]),
                      (((_ctx.presentFindingTaskObj.appId && _ctx.presentFindingTaskObj.appId==10003)|| _ctx.presentFindingTaskObj.treatmentType!=undefined))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                            _cache[146] || (_cache[146] = _createElementVNode("label", { class: "controllabel mb-2" }, "Treatment Type", -1)),
                            _cache[147] || (_cache[147] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.treatmentTypeBgColor(_ctx.presentFindingTaskObj.treatmentType)])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-xs", _ctx.treatmentTypeTextColor(_ctx.presentFindingTaskObj.treatmentType)])
                              }, _toDisplayString(_ctx.presentTask(_ctx.presentFindingTaskObj.treatmentType)||'N/A'), 3)
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_258, [
                        _cache[148] || (_cache[148] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                        _cache[149] || (_cache[149] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingTaskObj.dueDate != undefined || _ctx.presentFindingTaskObj.dueDate != null)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: _normalizeClass(["mt-2 text-sm rounded w-24", _ctx.shouldStyleDueDate(_ctx.presentFindingTaskObj) ? _ctx.colorForDueDate(_ctx.presentFindingTaskObj.dueDate) : '']),
                              "\"": ""
                            }, _toDisplayString(_ctx.formatDate(_ctx.presentFindingTaskObj.dueDate)), 3))
                          : (_openBlock(), _createElementBlock("p", _hoisted_259, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_260, [
                        _cache[150] || (_cache[150] = _createElementVNode("label", { class: "controllabel" }, "Team Representative", -1)),
                        _cache[151] || (_cache[151] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingTaskObj.teamOwner != undefined || _ctx.presentFindingTaskObj.teamOwner != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_261, _toDisplayString(_ctx.getPersonName(_ctx.presentFindingTaskObj.teamOwner)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_262, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_263, [
                        _cache[152] || (_cache[152] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                        _cache[153] || (_cache[153] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingTaskObj.department != undefined || _ctx.presentFindingTaskObj.department != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_264, _toDisplayString(_ctx.getTeamName(_ctx.presentFindingTaskObj.department)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_265, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_266, [
                        _cache[154] || (_cache[154] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                        _cache[155] || (_cache[155] = _createElementVNode("br", null, null, -1)),
                        (Object.keys(_ctx.presentFindingTaskObj).includes('location') && _ctx.presentFindingTaskObj.location != undefined && _ctx.presentFindingTaskObj.location != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_267, _toDisplayString(_ctx.getEntityName(_ctx.presentFindingTaskObj.location)), 1))
                          : (Object.keys(_ctx.presentFindingTaskObj).includes('location') && !Object.keys(_ctx.presentFindingTaskObj).includes('entity') && _ctx.presentFindingTaskObj.location != '' && _ctx.presentFindingTaskObj.location != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_268, _toDisplayString(_ctx.getEntity(_ctx.presentFindingTaskObj.location)), 1))
                            : (Object.keys(_ctx.presentFindingTaskObj).includes('entity') && _ctx.presentFindingTaskObj.entity != '' && _ctx.presentFindingTaskObj.entity != null && _ctx.presentFindingTaskObj.entity != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_269, _toDisplayString(_ctx.getEntity(_ctx.presentFindingTaskObj.entity)), 1))
                              : (Object.keys(_ctx.presentFindingTaskObj).includes('location') && _ctx.presentFindingTaskObj.location=='' && _ctx.presentFindingTaskObj.department!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_270, _toDisplayString(_ctx.getLocationNameForSystem(_ctx.presentFindingTaskObj.department)), 1))
                                : (_ctx.presentFindingTaskObj.location==null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (val) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: val._id
                                        }, [
                                          (val._id==_ctx.presentFindingTaskObj.department && val.entityType==20301)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_272, _toDisplayString('Global')))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_273, "N/A"))
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.importpopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_274, [
              _createElementVNode("div", _hoisted_275, [
                _createElementVNode("div", _hoisted_276, [
                  _createElementVNode("div", _hoisted_277, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File'), 1),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelIcon()))
                    }, _cache[157] || (_cache[157] = [
                      _createElementVNode("img", {
                        src: _imports_16,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]),
                  _cache[165] || (_cache[165] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_278, [
                    _createElementVNode("div", _hoisted_279, [
                      _createElementVNode("div", _hoisted_280, [
                        _createElementVNode("div", _hoisted_281, [
                          _createElementVNode("div", _hoisted_282, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_283, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Title' : 'File Name'), 1),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.inputFileName.$error }]),
                                type: "text",
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.inputFileName) = $event)),
                                placeholder: _ctx.evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename',
                                onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                              }, null, 42, _hoisted_284), [
                                [
                                  _vModelText,
                                  _ctx.inputFileName,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.inputFileName.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                                    (_ctx.v$.inputFileName.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_286, "Required"))
                                      : (_ctx.v$.inputFileName.required && _ctx.v$.inputFileName.restrictCharacters50.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_287, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.evidenceAttachMode === 'file')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_288, [
                                  _cache[160] || (_cache[160] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                                  _createElementVNode("input", {
                                    type: "file",
                                    ref: "fileInput",
                                    class: "hidden",
                                    id: "upload",
                                    onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                                  }, null, 544),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-auto rounded-sm mt-2 p-8 flex flex-col items-center justify-center text-center transition border-2 border-dashed border-lightgrey bg-whitegrey", {
                    'is-invalid': _ctx.v$.fileToUpload.$error || _ctx.pdfValidation,
                    'border-primary': _ctx.isDragOver
                  }]),
                                    onDragenter: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                    onDragover: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                    onDragleave: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"])),
                                    onDrop: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDrop && _ctx.onFileDrop(...args)), ["prevent"]))
                                  }, [
                                    _cache[159] || (_cache[159] = _createElementVNode("img", {
                                      src: _imports_17,
                                      class: "h-10 w-10 mb-3",
                                      alt: "Upload file"
                                    }, null, -1)),
                                    (_ctx.fileName === '')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_289, " Drag and drop your file here "))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_290, _toDisplayString(_ctx.fileName), 1)),
                                    _createElementVNode("div", _hoisted_291, [
                                      _cache[158] || (_cache[158] = _createElementVNode("label", {
                                        for: "upload",
                                        class: "cursor-pointer"
                                      }, [
                                        _createElementVNode("span", { class: "btnprimary text-xs gap-1" }, [
                                          _createElementVNode("img", {
                                            src: _imports_18,
                                            class: "h-4 w-4",
                                            alt: ""
                                          }),
                                          _createTextVNode(" Browse ")
                                        ])
                                      ], -1)),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["filterButton text-xs gap-1", _ctx.fileName === '' ? 'filterButtondisabled pointer-events-none' : '']),
                                        disabled: _ctx.fileName === '',
                                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedFile && _ctx.clearSelectedFile(...args)))
                                      }, " Cancel ", 10, _hoisted_292)
                                    ])
                                  ], 34),
                                  _createElementVNode("div", _hoisted_293, [
                                    (_ctx.v$.fileToUpload.$invalid && !_ctx.pdfValidation && (_ctx.v$.fileToUpload.$error || _ctx.pdfValidation))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_294, " File upload is required "))
                                      : _createCommentVNode("", true),
                                    (_ctx.pdfValidation && !_ctx.v$.fileToUpload.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_295, " This File Format is not Supported "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _cache[161] || (_cache[161] = _createElementVNode("div", { class: "mt-2 flex flex-col items-center" }, [
                                    _createElementVNode("p", { class: "text-xs text-placeholder" }, " Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4 "),
                                    _createElementVNode("p", { class: "text-xs text-placeholder mt-1" }, " Maximum File Size: 50 MB ")
                                  ], -1))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.evidenceAttachMode === 'url')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_296, [
                                  _cache[162] || (_cache[162] = _createElementVNode("label", { class: "controllabel" }, "URL", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.evidenceUrl.$error }]),
                                    type: "url",
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.evidenceUrl) = $event)),
                                    placeholder: "URL",
                                    onInput: _cache[37] || (_cache[37] = ($event: any) => (_ctx.v$.evidenceUrl.$touch()))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.evidenceUrl,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.evidenceUrl.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_297, [
                                        (_ctx.v$.evidenceUrl.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_298, "Required"))
                                          : (_ctx.v$.evidenceUrl.httpUrl.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_299, "URL must use http or https"))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_300, [
                              _cache[163] || (_cache[163] = _createElementVNode("label", { class: "controllabel" }, "Evidence Date", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.evidenceDate) = $event)),
                                type: "date",
                                class: _normalizeClass(["mt-2 w-full", {
                        'inputboxstylingForSelectAtPopup': _ctx.evidenceDate == '',
                        'stylingForInputboxstylingForSelectAtPopup': _ctx.evidenceDate != '',
                        'is-invalid':_ctx.v$.evidenceDate.$error
                        }]),
                                onFocus: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                style: {"height":"28px"},
                                onkeydown: "return false",
                                placeholder: "Select Date",
                                max: _ctx.todayDate
                              }, null, 42, _hoisted_301), [
                                [_vModelText, _ctx.evidenceDate]
                              ]),
                              (_ctx.v$.evidenceDate.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                    (_ctx.v$.evidenceDate.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_303, "Evidence date is required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[164] || (_cache[164] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_304, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", 
                _ctx.isEvidenceSaveDisabled
                  ? 'btndisabled pointer-events-none '
                  : 'btnprimary']),
                          disabled: _ctx.clickOnButtonAtAddingFile,
                          onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                        }, " Save ", 10, _hoisted_305)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showApprovalPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showApprovalPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_306, [
              _cache[167] || (_cache[167] = _createElementVNode("h1", null, "Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onCrossbtn()))
              }, _cache[166] || (_cache[166] = [
                _createElementVNode("img", {
                  src: _imports_16,
                  class: "cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_307, [
              _createElementVNode("div", _hoisted_308, [
                _createElementVNode("div", _hoisted_309, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_310, [
                        _createElementVNode("div", _hoisted_311, [
                          _createElementVNode("div", _hoisted_312, [
                            _createElementVNode("div", _hoisted_313, [
                              _cache[168] || (_cache[168] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.taskObj.approver,
                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.taskObj.approver) = $event)),
                                suggestions: _ctx.userOptions,
                                onComplete: _ctx.asyncApproverFind,
                                optionLabel: "label",
                                optionValue: "value",
                                forceSelection: true,
                                placeholder: "Name of the Authority",
                                class: _normalizeClass([{ 'p-invalid': _ctx.v$.taskObj.approver.$error }, "p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect"])
                              }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                              (_ctx.v$.taskObj.approver.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                    (_ctx.v$.taskObj.approver.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_315, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_316, [
                            _createElementVNode("div", _hoisted_317, [
                              _cache[169] || (_cache[169] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.taskObj.approvalComments.$error }]),
                                placeholder: "Comments",
                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event)),
                                onInput: _cache[44] || (_cache[44] = ($event: any) => (_ctx.v$.taskObj.approvalComments.$touch()))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.taskObj.approvalComments,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.taskObj.approvalComments.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_318, [
                                    (_ctx.v$.taskObj.approvalComments.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_319, "Required"))
                                      : (_ctx.v$.taskObj.approvalComments.required && _ctx.v$.taskObj.approvalComments.restrictCharacters1000.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_320, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[170] || (_cache[170] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_321, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-2", 
                !_ctx.taskObj.approver && !_ctx.taskObj.approvalComments
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary", 
                !_ctx.taskObj.approver && !_ctx.taskObj.approvalComments
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.applyAuthority()))
                  }, " Save ", 10, _hoisted_322)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showRejectPopupForNormalApproval)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.showRejectPopupForNormalApproval
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_323, [
              _cache[172] || (_cache[172] = _createElementVNode("h1", null, "Justification to Reject an Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onCrossBtnForNormalApproval()))
              }, _cache[171] || (_cache[171] = [
                _createElementVNode("img", {
                  src: _imports_16,
                  class: "cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_324, [
              _createElementVNode("div", _hoisted_325, [
                _createElementVNode("div", _hoisted_326, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_327, [
                        _createElementVNode("div", _hoisted_328, [
                          _cache[173] || (_cache[173] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.normalJustification.justification.$error }]),
                            placeholder: "Comments",
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.normalJustification.justification) = $event)),
                            onInput: _cache[49] || (_cache[49] = ($event: any) => (_ctx.v$.normalJustification.justification.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.normalJustification.justification,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.normalJustification.justification.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_329, [
                                (_ctx.v$.normalJustification.justification.restrictCharacters1000.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_330, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[174] || (_cache[174] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_331, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-2", 
                _ctx.normalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onCancelbtnForNormalApproval()))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButtonForNormal,
                    class: _normalizeClass(["btnprimary", 
                _ctx.normalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.ApprovalforInprogress(10410)))
                  }, " Save ", 10, _hoisted_332)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showRejectPopupAtInReview)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          popUp: _ctx.showRejectPopupAtInReview
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_333, [
              _cache[176] || (_cache[176] = _createElementVNode("h1", null, "Justification to Reject an Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onCrossBtnForFinalApproval()))
              }, _cache[175] || (_cache[175] = [
                _createElementVNode("img", {
                  src: _imports_16,
                  class: "cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_334, [
              _createElementVNode("div", _hoisted_335, [
                _createElementVNode("div", _hoisted_336, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_337, [
                        _createElementVNode("div", _hoisted_338, [
                          _cache[177] || (_cache[177] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.finalJustification.justification.$error }]),
                            placeholder: "Comments",
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.finalJustification.justification) = $event)),
                            onInput: _cache[54] || (_cache[54] = ($event: any) => (_ctx.v$.finalJustification.justification.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.finalJustification.justification,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.finalJustification.justification.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_339, [
                                (_ctx.v$.finalJustification.justification.restrictCharacters1000.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_340, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[178] || (_cache[178] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_341, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-2", 
                _ctx.finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.onCancelbtnForFinalApproval()))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButtonForFinal,
                    class: _normalizeClass(["btnprimary", 
                _ctx.finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.approveOrRejectForActionTasktoComplete(10401, 9)))
                  }, " Save ", 10, _hoisted_342)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteEvidenceConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_343, [
          _createElementVNode("div", {
            class: "evidence-delete-backdrop",
            onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
          }),
          _createElementVNode("div", _hoisted_344, [
            _cache[179] || (_cache[179] = _createElementVNode("div", { class: "evidence-delete-dialog-title" }, [
              _createElementVNode("div", { class: "evidence-delete-warning" }, [
                _createElementVNode("img", {
                  src: _imports_19,
                  class: "evidence-delete-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Delete Evidence")
            ], -1)),
            _cache[180] || (_cache[180] = _createElementVNode("p", { class: "evidence-delete-dialog-message" }, "Are you sure you want to delete this evidence?", -1)),
            _createElementVNode("div", _hoisted_345, [
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-cancel",
                onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-ok",
                onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteEvidence && _ctx.confirmDeleteEvidence(...args)))
              }, "OK")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.linkEvidencePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_346, [
          _createElementVNode("div", {
            class: "link-existing-backdrop",
            onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
          }),
          _createElementVNode("div", _hoisted_347, [
            _cache[190] || (_cache[190] = _createElementVNode("div", { class: "link-existing-title" }, [
              _createElementVNode("span", {
                class: "link-existing-warning",
                "aria-hidden": "true"
              }, [
                _createElementVNode("img", {
                  src: _imports_19,
                  class: "link-existing-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Link Existing Evidence")
            ], -1)),
            _cache[191] || (_cache[191] = _createElementVNode("p", { class: "link-existing-message" }, "Select evidence from the past year listed below.", -1)),
            _createElementVNode("div", _hoisted_348, [
              _createElementVNode("div", _hoisted_349, [
                _createElementVNode("div", _hoisted_350, "EXISTING EVIDENCE (" + _toDisplayString(_ctx.filteredSortedExistingEvidences.length) + ")", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "filterButton flex",
                  onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.toggleExistingEvidenceFilters && _ctx.toggleExistingEvidenceFilters(...args)))
                }, _cache[181] || (_cache[181] = [
                  _createElementVNode("img", {
                    src: _imports_20,
                    class: "filterIcon"
                  }, null, -1),
                  _createTextVNode(" Filters ")
                ]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["link-existing-table-wrap", { 'link-existing-table-wrap--empty': _ctx.filteredSortedExistingEvidences.length === 0 }])
              }, [
                _createElementVNode("table", _hoisted_351, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[186] || (_cache[186] = _createElementVNode("th", { class: "link-existing-col-check" }, null, -1)),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.sortExistingEvidence('filename')))
                      }, [
                        _createElementVNode("div", _hoisted_352, [
                          _cache[182] || (_cache[182] = _createElementVNode("div", { class: "table-header-label" }, "TITLE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'filename' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.sortExistingEvidence('sourceTaskId')))
                      }, [
                        _createElementVNode("div", _hoisted_353, [
                          _cache[183] || (_cache[183] = _createElementVNode("div", { class: "table-header-label" }, "TASK ID", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'sourceTaskId' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.sortExistingEvidence('evidenceType')))
                      }, [
                        _createElementVNode("div", _hoisted_354, [
                          _cache[184] || (_cache[184] = _createElementVNode("div", { class: "table-header-label" }, "TYPE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceType' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.sortExistingEvidence('evidenceDate')))
                      }, [
                        _createElementVNode("div", _hoisted_355, [
                          _cache[185] || (_cache[185] = _createElementVNode("div", { class: "table-header-label" }, "EVIDENCE DATE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceDate' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ])
                    ]),
                    (_ctx.showExistingEvidenceFilters)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_356, [
                          _cache[187] || (_cache[187] = _createElementVNode("td", { class: "link-existing-col-check" }, null, -1)),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.existingEvidenceFilters.filename) = $event)),
                              placeholder: "Search",
                              onClick: _cache[67] || (_cache[67] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.filename,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.existingEvidenceFilters.sourceTaskId) = $event)),
                              placeholder: "Search",
                              onClick: _cache[69] || (_cache[69] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.sourceTaskId,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.existingEvidenceFilters.evidenceType) = $event)),
                              placeholder: "Search",
                              onClick: _cache[71] || (_cache[71] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.evidenceType,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _cache[188] || (_cache[188] = _createElementVNode("td", null, null, -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.filteredSortedExistingEvidences.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_357, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedExistingEvidences, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.optionKey
                          }, [
                            _createElementVNode("td", _hoisted_358, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.isExistingEvidenceSelected(row),
                                onChange: ($event: any) => (_ctx.toggleExistingEvidence(row))
                              }, null, 40, _hoisted_359)
                            ]),
                            _createElementVNode("td", {
                              title: row.filename
                            }, _toDisplayString(row.filename), 9, _hoisted_360),
                            _createElementVNode("td", null, _toDisplayString(row.sourceTaskId), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.existingEvidenceTypeLabel(row)), 1),
                            _createElementVNode("td", null, _toDisplayString(row.evidenceDate ? _ctx.formatFileAttachedTime(row.evidenceDate) : 'N/A'), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_361, _cache[189] || (_cache[189] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            class: "link-existing-empty",
                            colspan: "5"
                          }, "No Records Found")
                        ], -1)
                      ])))
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_362, [
              _createElementVNode("button", {
                type: "button",
                class: "link-existing-cancel",
                onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["link-existing-save", _ctx.selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : '']),
                onClick: _cache[73] || (_cache[73] = 
//@ts-ignore
(...args) => (_ctx.saveLinkedEvidence && _ctx.saveLinkedEvidence(...args)))
              }, "Save", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}